<page-layout>
    <div class="blockcode pt-5">
        <div class="header">Switch</div>
        <div class="example d-flex flex-column">
            <CDBSwitch></CDBSwitch>
            <CDBSwitch [checked]=true></CDBSwitch>
        </div>
    </div>
</page-layout>